"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(["\n    width: 100%;\n    max-width: ", ";\n    height: ", "em;\n    border-radius: ", "em;\n    border: 1px solid\n        ", ";\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n    padding: 0 ", "em;\n    margin: 0\n        ", "\n        auto ", "em;\n    margin-bottom: ", "em;\n    font-size: 1em;\n    background-image: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' version='1.1' width='32' height='24' viewBox='0 0 32 24'><polygon points='0,0 32,0 16,24' style='fill: rgb%28138, 138, 138%29'></polygon></svg>\");\n    background-origin: content-box;\n    background-position: right -1rem center;\n    background-repeat: no-repeat;\n    background-size: 9px 6px;\n    padding-right: 1.5rem;\n    appearance: none;\n"], ["\n    width: 100%;\n    max-width: ", ";\n    height: ", "em;\n    border-radius: ", "em;\n    border: 1px solid\n        ", ";\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n    padding: 0 ", "em;\n    margin: 0\n        ", "\n        auto ", "em;\n    margin-bottom: ", "em;\n    font-size: 1em;\n    background-image: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' version='1.1' width='32' height='24' viewBox='0 0 32 24'><polygon points='0,0 32,0 16,24' style='fill: rgb%28138, 138, 138%29'></polygon></svg>\");\n    background-origin: content-box;\n    background-position: right -1rem center;\n    background-repeat: no-repeat;\n    background-size: 9px 6px;\n    padding-right: 1.5rem;\n    appearance: none;\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _functions = require("../../functions");

var _label = require("./label");

var _label2 = _interopRequireDefault(_label);

var _inputError = require("./inputError");

var _inputError2 = _interopRequireDefault(_inputError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Select = _styledComponents2.default.select(_templateObject, function (props) {
    return props.expanded ? "100%" : "10em";
}, function (props) {
    return props.theme.input.sizes[props.size];
}, function (props) {
    return props.theme.input.radius;
}, function (props) {
    return props.error ? props.theme.input.error.borderColor : props.theme.input.borderColor;
}, function (props) {
    return props.theme.input.sizes[props.size] / 4;
}, function (props) {
    return props.expanded || props.align == "right" ? 0 : "0.4em";
}, function (props) {
    return props.align == "right" ? "0.4em" : 0;
}, function (props) {
    return props.theme.input.margin;
});

var SelectField = function SelectField(_ref) {
    var options = _ref.options,
        type = _ref.type,
        name = _ref.name,
        onChange = _ref.onChange,
        label = _ref.label,
        inlineLabel = _ref.inlineLabel,
        emptyOption = _ref.emptyOption,
        readOnly = _ref.readOnly,
        error = _ref.error,
        rest = _objectWithoutProperties(_ref, ["options", "type", "name", "onChange", "label", "inlineLabel", "emptyOption", "readOnly", "error"]);

    var handleChange = function handleChange(event) {
        onChange({
            name: name,
            value: event.target.value
        });
    };
    return _react2.default.createElement(
        "span",
        null,
        label && _react2.default.createElement(
            _label2.default,
            _extends({ name: name, label: label }, rest),
            label
        ),
        " ",
        _react2.default.createElement(
            Select,
            _extends({ onChange: handleChange }, rest),
            _react2.default.createElement(
                "option",
                { value: "" },
                emptyOption
            ),
            options && options.map(function (opt, index) {
                return _react2.default.createElement(
                    "option",
                    { value: opt.value, key: index },
                    opt.text
                );
            })
        ),
        _react2.default.createElement(_inputError2.default, { error: error })
    );
};

SelectField.displayName = "SelectField";

SelectField.propTypes = {
    name: _propTypes2.default.string.isRequired,
    onChange: _propTypes2.default.func.isRequired,
    options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        value: _propTypes2.default.any,
        text: _propTypes2.default.string.isRequired
    })),
    size: _propTypes2.default.string,
    expanded: _propTypes2.default.bool,
    inlineLabel: _propTypes2.default.bool,
    input: _propTypes2.default.object,
    label: _propTypes2.default.string,
    emptyOption: _propTypes2.default.string,
    error: _propTypes2.default.string
};
SelectField.defaultProps = {
    size: "default",
    expanded: false,
    inlineLabel: true,
    emptyOption: "--Select One--",
    error: ""
};
exports.default = SelectField;


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/form/selectField.js
// module id = 1007
// module chunks = 95715928098905 168707334958949